import { useState, useRef } from 'react';

export default function useRefresh() {
  // eslint-disable-next-line
  const [identifer, setIdentifer] = useState(0);
  const refreshRef = useRef(function () {
    setIdentifer((n) => n + 1);
  });
  return refreshRef.current;
}
